// extracted by mini-css-extract-plugin
export var image = "index-module--image--67420";
export var logoItem = "index-module--logoItem--92ce3";
export var logoLink = "index-module--logoLink--d2ccd";
export var logos = "index-module--logos--75b42";
export var partners = "index-module--partners--f58ee";
export var title = "index-module--title--5d4e4";